import usePWAInstall from "../usePWAInstall";
import RemoteConfigService from "../../RemoteConfigService";
import Localize from "../../Localize/Localize";
import LocalizeKeys from "../../Localize/LocalizeKeys";
import { useState } from "react";
import UserAgent from "../../Utils/UserAgent";

const renderInstallPWABanner = (handleInstallClick, setDismissed) => (
  <div className="pwa-banner" role="dialog" aria-live="polite">
    <div className="pwa-banner__content">
      <div className="pwa-banner__text">
        {Localize.translate(LocalizeKeys.INSTALL_APP)}
      </div>
      <button className="pwa-banner__btn" onClick={handleInstallClick}>
        {Localize.translate(LocalizeKeys.INSTALL_BUTTON)}
      </button>
    </div>
    <button className="pwa-banner__close" onClick={() => setDismissed(true)} aria-label="Close">
      ×
    </button>
  </div>
);

const renderManualInstallBanner = (setDismissed) => (
  <div className="pwa-banner" role="dialog" aria-live="polite">
    <div className="pwa-banner__help">
      <p>
        {Localize.translateByBrowserOrFallback(LocalizeKeys.INSTALL_DESKTOP_WINDOWS_MANUAL)}
      </p>
    </div>
    <button className="pwa-banner__close" onClick={() => setDismissed(true)} aria-label="Close">
      ×
    </button>
  </div>
);

const DesktopWindowsInstallBanner = () => {
  const { canInstall, promptInstall, isStandalone, supportsManualAddToHome } = usePWAInstall();
  const [dismissed, setDismissed] = useState(false);

  console.log("[PWA] DesktopWindowsInstallBanner", { canInstall, supportsManualAddToHome });

  if (dismissed || isStandalone) return null;

  const handleInstallClick = async () => {
    const result = await promptInstall();
    console.log("[PWA] DesktopWindowsInstallBanner outcome:", result.outcome);
    setDismissed(true);
  };

  if (UserAgent.isOpera()) return null;

  if (canInstall && RemoteConfigService.getLandingConfigValue("ToastInstallPWA"))
    return renderInstallPWABanner(handleInstallClick, setDismissed);

  if (supportsManualAddToHome && RemoteConfigService.getLandingConfigValue("ToastAddFavorites"))
    return renderManualInstallBanner(setDismissed);

  return null;
};

export default DesktopWindowsInstallBanner;